export const isEmpty = (value: string): boolean => {
  return !value || value.trim() === "";
}
